import { Component, inject } from '@angular/core';
import { DialogService } from '@shared/services/dialog';

@Component({
  selector: 'app-language-button',
  standalone: false,
  templateUrl: './language-button.component.html',
  styleUrl: './language-button.component.scss',
})
export class LanguageButtonComponent {
  readonly dialog = inject(DialogService);

  activate() {
    this.dialog.openLanguageSwitcher();
  }
}
